import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Focus from '../components/Focus';
import Programmes from '../components/Programmes';
import Partner from '../components/Partner';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <About />
      <Focus />
      <Programmes />
      <Partner />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
}